<script>
import {
  required
} from "vuelidate/lib/validators";
import { notify } from '@/helpers/notify' 

export default {
  name: 'CreateModal',
  props:[
      "list"
  ],
  data() {
    return {
      form: {
        type: ''
      },
      submitted: false,
      blok: true,
    };
  },
  validations: {
    form: {  
      ip: { required },
      type: { required },
      subnet: { required },
    },
  },
  watch:{
    list(props){
      this.form = {...props}
    }
  },
  methods: {
    handleSubmit() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {

        if(this.form.id)
          this.update();
          else
          this.create();

          this.$emit('loadItems');
      }
      this.submitted = false;
    },
    async create(){
      await this.$http.post('/ips/store', {...this.form,blok:this.blok})
        .then(resp => {
          this.form = {};
          return notify.success(resp.data.message)
        })
        .catch(error => error)
    },
    async update(){
      await this.$http.put('/ips/' + this.form.id , this.form)
        .then(resp => {
          this.form = {};
          return notify.success(resp.data.message)
        })
        .catch(error => error)
    },
    async remove(id){
      await this.$http.delete('/ips/' + id)
        .then(resp => {
          if(resp.data.code !==  100)  return notify.error(resp.data.message)
           return notify.success(resp.data.message)
         })
        .catch(error => error)
    },
    close(){
      this.$parent.$bvModal.hide('modal-scoped')
    }
  },
};
</script> 

<template>
  <b-modal id="modal-scoped" title="İp Ekle"  no-close-on-backdrop hide-footer>
      <form @submit.prevent="handleSubmit">
        <div class="row">
          <div class="col-12">
            <div class="mb-3">
              <label>İp Tipi Seçiniz</label>
              <select v-model="form.type" class="form-select" :class="{
                      'is-invalid': submitted && $v.form.type.$error,
                    }">
                      <option value=''>Seçiniz</option>
                      <option value="s">Statik İp</option>
                      <option value="l">Lokal İp</option>
              </select>
              <div
                v-if="submitted && !$v.form.type.required"
                class="invalid-feedback"
              >
                Bu alanı doldurmak zorunludur.
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="row mb-3">
              <div class="col-md-6">
                  <label for="ip">İp</label>
                  <input
                    id="ip"
                    v-model="form.ip"
                    type="text"
                    class="form-control"
                    placeholder="İp"
                    :class="{
                      'is-invalid': submitted && $v.form.ip.$error,
                    }"
                  />
                  <div
                    v-if="(submitted && !$v.form.ip.required) || !$v.form.type.required"
                    class="invalid-feedback"
                  >
                      Bu alanı doldurmak zorunludur.
                  </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <ul class="nav nav-tabs nav-justified">
                    <li class="nav-item" @click.prevent="blok=true">
                      <a class="nav-link" :class="{ active:blok === true }"   style="padding:3px" href="#">Blok Gir</a>
                    </li>
                    <li class="nav-item" @click.prevent="blok=false" >
                      <a class="nav-link" :class="{ active:blok === false  }" style="padding:3px" href="#">Aralık Gir</a>
                    </li>
                  </ul>
                  <div class="input-group mb-3">
                    <div class="input-group-append">
                      <span class="input-group-text" v-if="blok === true">/</span>
                      <span class="input-group-text" v-else>-</span>
                    </div>
                    <input
                    id="subnet"
                    v-model="form.subnet"
                    type="text"
                    class="form-control"
                    placeholder="24"
                    :class="{
                      'is-invalid': submitted && $v.form.subnet.$error,
                    }"
                  />
                  </div>
                 
                  <div
                    v-if="submitted && !$v.form.subnet.required"
                    class="invalid-feedback"
                  >
                  Bu alanı doldurmak zorunludur.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-between mt-3">
        <div>
          <b-button variant="danger"  v-if="form.id" @click="remove(form.id)">Sil</b-button>
        </div>
        <div>
          <b-button variant="light" @click="close()">Vazgeç</b-button>
          <b-button 
            v-if="form.id"
            type="submit" 
            variant="warning" 
            class="ms-1"
            >Güncelle
          </b-button>
          <b-button 
            v-else
            type="submit" 
            variant="success" 
            class="ms-1"
            >Oluştur
          </b-button>
        </div>
        </div>
      </form>
    </b-modal>
</template>